import { Field, NumericInput, RadioGroup, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import {
  IEmbeddedTestProps,
  VolumeDeterminationMethod,
} from 'Components/Worksheets/MoistureContentWorksheet/BsEn/types';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { BsEnMeasurementsMultiTraysGridSection } from './MeasurementsMultiTraysGridSection';
import { BsEnMeasurementsSingleTraySection } from './MeasurementsSingleTraySection';

let BsEnMeasurementsSection: React.FC<IEmbeddedTestProps> = ({ createWorksheetSelector, isEmbeddedTest }) => {
  const lightweightAggregate: boolean = useSelector(
    pipe(createWorksheetSelector!('Preparation.LightweightAggregate'), valueOrDefault(false))
  );

  const singleTray = useSelector(pipe(createWorksheetSelector!('DryingTrays'), (p) => p?.length < 2));

  const methodOptions: Array<{ label: string; value: VolumeDeterminationMethod }> = [
    { label: 'Bulk Density', value: VolumeDeterminationMethod.BulkDensity },
    { label: 'Direct Entry', value: VolumeDeterminationMethod.DirectEntry },
  ];

  const isBulkDensity = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.VolumeDeterminationMethod'),
      (p) => p === VolumeDeterminationMethod.BulkDensity
    )
  );

  const isDirectEntry = useSelector(
    pipe(
      createWorksheetSelector!('Measurements.VolumeDeterminationMethod'),
      (p) => p === VolumeDeterminationMethod.DirectEntry
    )
  );

  return (
    <SectionGroup>
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          name="Measurements.VolumeDeterminationMethod"
          options={methodOptions}
          visible={lightweightAggregate && !isEmbeddedTest}
        />
        <Field
          input={isEmbeddedTest ? <TextOutput /> : <NumericInput />}
          name="Measurements.BulkDensity"
          visible={lightweightAggregate && isBulkDensity}
        />
        <Field input={<NumericInput />} name="Measurements.Volume" visible={lightweightAggregate && isDirectEntry} />
      </ListFieldSection>
      {singleTray ? <BsEnMeasurementsSingleTraySection /> : <BsEnMeasurementsMultiTraysGridSection />}
    </SectionGroup>
  );
};
BsEnMeasurementsSection = withInjectedProps(BsEnMeasurementsSection);
export { BsEnMeasurementsSection };
